import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AuctionCard } from "../components/exchange/auction";
import auctionService from "../services/auctionService";
import {
  Box,
  CircularProgress,
  Alert,
  Paper,
  Typography,
  Chip,
  Divider,
  Stack,
} from "@mui/material";
import { Item } from "../types/Item";

const AuctionDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [item, setItem] = useState<Item | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchItem = async () => {
      try {
        const response = await auctionService.getItem(id!);
        setItem(response.item);
      } catch (err: any) {
        setError("Failed to load auction.");
      } finally {
        setLoading(false);
      }
    };
    fetchItem();
  }, [id]);

  if (loading)
    return (
      <Box p={3} display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  if (error)
    return (
      <Box p={3}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  if (!item) return null;

  return (
    <Box
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="#f4f6f8"
      py={6}
    >
      <Paper
        elevation={4}
        sx={{
          maxWidth: 600,
          width: "100%",
          borderRadius: 4,
          p: 3,
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
        }}
      >
        <AuctionCard item={item} />
        <Divider sx={{ my: 3 }} />
        <Stack direction="row" spacing={2} mb={2}>
          <Chip label={item.status.toUpperCase()} color="info" />
          {item.category && <Chip label={item.category} color="secondary" />}
        </Stack>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          {item.title}
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={2}>
          {item.description}
        </Typography>
        <Typography variant="body2" color="text.disabled">
          Auction ID: {item.id}
        </Typography>
      </Paper>
    </Box>
  );
};

export default AuctionDetail;
